import React from "react";
import { FaDraftingCompass, FaProjectDiagram, FaTools, FaCogs, FaBuilding, FaWarehouse } from "react-icons/fa";
import { motion } from "framer-motion";
import { AppConstant } from "../AppConstant";
import Header from "./Header";
import Footer from "./Footer";

const OurServices = () => {
  const services = [
    {
      icon: <FaDraftingCompass size={30} color="white" />,
      title: "Structural Detailing and BIM Modeling",
      text: "Our team of architects and structural engineers uses AutoCAD, Revit, and Tekla to create precise construction documents. We handle projects from small residential homes to large multi-storied hospitals, ensuring clarity and efficiency throughout the construction process.",
      color: "#00c6c2",
    },
    {
      icon: <FaProjectDiagram size={30} color="white" />,
      title: "Structural Analysis and Design",
      text: "We provide comprehensive structural analysis and design for various projects, from high-rise buildings to specialized mobile medical units. Using ETABS, STAAD, SAP, SAFE, Forteweb,Visual Analysis and ENERCALC, we ensure safe, economical, and reliable structural solutions.",
      color: "#2196f3",
    },
    {
      icon: <FaTools size={30} color="white" />,
      title: "Design and Detailing",
      text: "We offer detailed design and drafting services for Reinforced concrete, Steel, Cold-Formed Steel, Aluminum, Pre-Cast, and Lumber Buildings, ensuring accuracy and constructability across all structural systems.",
      color: "#f44336",
    },
    {
      icon: <FaCogs size={30} color="white" />,
      title: "Steel Connection Design",
      text: "Our experts design steel connections using advanced tools like IDEA StatiCa, working with AISC-certified fabricators to ensure efficiency, safety, and compliance with industry standards.",
      color: "#ff9800",
    },
    {
      icon: <FaBuilding size={30} color="white" />,
      title: "Stairs, Railing,Ladders and Platform Design",
      text: "We specialize in the design of stairs, railings,Ladders and platforms, collaborating with top AISC-certified fabricators to deliver precise, safe, and functional solutions for all building types.",
      color: "#00c6c2",
    },
    {
      icon: <FaWarehouse size={30} color="white" />,
      title: "Sandwich and Tilt-up Wall Panel Design and Detailing",
      text: "We provide design and detailing services for sandwich and tilt-up Wall panel systems, serving major clients and ensuring durable, cost-effective, and efficient structural solutions for warehouses and industrial facilities.",
      color: "#2196f3",
    },
  ];

  return (
    <>
      <Header />
      <div style={styles.container}>
        <motion.h2
          style={styles.heading}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Your Vision <span style={{ color: '#f37021' }}>Our Engineering</span>

        </motion.h2>
        <motion.p
          style={styles.subheading}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
        >
          From concept to creation — we build with precision.
        </motion.p>


        <div style={styles.servicesWrapper}>
          {services.map((service, index) => (
            <motion.div
              key={index}
              style={styles.card}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              whileHover={{ scale: 1.05, y: -5, boxShadow: "0px 20px 40px rgba(0,0,0,0.3)" }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div style={styles.tab(service.color)}>
                <motion.div
                  whileHover={{ rotate: 15 }}
                  transition={{ type: "spring", stiffness: 200 }}
                >
                  {service.icon}
                </motion.div>
              </div>
              <h3 style={styles.cardTitle(service.color)}>{service.title}</h3>
              <p style={styles.cardText}>{service.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "50px 20px",
    fontFamily: "Arial, sans-serif",
    // backgroundColor: "#f9fafc",
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: AppConstant.backgroundAttachmentscroller,
    backgroundColor: 'white'
  },
  heading: {
    fontSize: "60px",
    fontWeight: "bold",
    color: "#0A1733",
    marginBottom: "20px",
  },
  subheading: {
    maxWidth: 940,
    margin: "12px auto 32px",
    fontSize: '1rem',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: "bold",
    fontStyle: 'italic',
    marginLeft: 'auto',
    marginRight: 'auto',
    // color: 'lightgrey',
    color: '#0A1733',
    // textTransform: "capitalize",

    // textDecoration: "underline 2px rgb(255, 101, 0)",

    textUnderlineOffset: "10px",
    letterSpacing: "2px",
  },
  servicesWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "25px",
    flexWrap: "wrap",
  },
  card: {
    backgroundColor: "#fff",
    width: "280px",
    borderRadius: "15px",
    boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
    position: "relative",
    overflow: "hidden",
    padding: "60px 20px 30px",
    textAlign: "center",
    cursor: "pointer",
  },
  tab: (color) => ({
    position: "absolute",
    top: "0",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100px",
    height: "70px",
    backgroundColor: color,
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 5px 15px rgba(0,0,0,0.2)",
  }),
  cardTitle: (color) => ({
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "15px",
    color: color,
  }),
  cardText: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.6",
    // textTransform: "capitalize",
  },
};

export default OurServices;
